import React from "react";
import { Navigate } from "react-router-dom";
import Login from "../Screens/Auth/Login";
import SignUp from "../Screens/Auth/SignUp";
import DashboardPage from "../Screens/Admin/DashboardPage";
import AdminProfile from "../Components/Admin/AdminProfile";
import Client from "../Components/Master/Client";
import Media from "../Components/Master/Media";
import Agent from "../Components/Master/Agent";
import Staff from "../Components/Master/Staff";
import AllReleaseOrders from "../Components/ReleaseOrder/AllReleaseOrders";
import AllRo from "../Components/ReleaseOrder/AllRo";
import SubClient from "../Components/Master/SubClient";
import AddInvoice from "../Components/Invoice/AddInvoice";
import AllInvoice from "../Components/Invoice/AllInvoice";
import CreateInvoiceByReleaseOrder from "../Components/Invoice/CreateInvoiceByReleaseOrder";
import MyCompany from "../Components/Company/MyCompany";
import StaffAttendance from "../Components/Attendance/StaffAttendance";
import AllAttendance from "../Components/Attendance/AllAttendance";
import Splitbills from "../Components/Splitsbill/Splitbills";
import MediaDetails from "../Components/Master/MediaDetails";
import AllHolidays from "../Components/Holiday/AllHolidays";
import StaffSalary from "../Components/Salary/StaffSalary";
import Categories from "../Components/vendor/Categories";
import Products from "../Components/vendor/Products";
import Buyers from "../Components/vendor/Buyers";
import BuyerDetails from "../Components/vendor/BuyerDetails";
import AdvanceSalary from "../Components/Salary/AdvanceSalary";
import StaffLic from "../Components/Lic/StaffLic";
import Quotation from "../Components/Quotation/Quotation";
import AllQuotation from "../Components/Quotation/AllQuotation";
import EditQuotation from "../Components/Quotation/EditQuotation";
import BrandingCategory from "../Components/Branding/BrandingCategory";
import BrandingVendors from "../Components/Branding/BrandingVendors";
import ReferralAgencies from "../Components/Branding/ReferralAgencies";
import BrandingOrders from "../Components/Branding/BrandingOrders";
import EditReleaseOrder from "../Components/ReleaseOrder/EditReleaseOrder";
import AllVendors from "../Components/vendor/AllVendors";
import Purchase from "../Components/vendor/Purchase";
import EditInvoice from "../Components/Invoice/EditInvoice";
import AdvertisingType from "../Components/Quotation/AdvertisingType";
import MediaRate from "../Components/Quotation/MediaRate";
import AllSplitbills from "../Components/Splitsbill/AllSplitbills";
import QuotationCategory from "../Components/Quotation/QuotationCategory";
import SplitBillDetails from "../Components/Splitsbill/SplitBillDetails";
import CreateSizeWiseSplitBill from "../Components/Splitsbill/CreateSizeWiseSplitBill";
import AddSplitSizes from "../Components/Splitsbill/AddSplitSizes";
import EditSizeWiseSplitBill from "../Components/Splitsbill/Editsizewisesplitbill";
import EditSplitSizes from "../Components/Splitsbill/Editsplitsizes";
import SalaryCount from "../Components/Salary/SalaryCount";
import AllInvoicePayments from "../Components/InvoicePayments/AllInvoicePayments";
import AllReleaseOrderPayments from "../Components/InvoicePayments/AllReleaseOrderPayments";
import FinanceReports from "../Components/Reports/FinanceReports";
import BusinessReports from "../Components/Reports/BusinessReports";
import SalaryAndAttendanceReport from "../Components/Reports/SalaryAndAttendanceReport";

const userRoutes = [
  {
    path: "/admin/",
    exact: true,
    component: <Navigate to="/admin/dashboard" />,
  },

  { path: "/admin/dashboard", component: <DashboardPage /> },
  { path: "/admin/user-profile", component: <AdminProfile /> },
  { path: "/admin/master/client", component: <Client /> },
  { path: "/admin/master/sub-clients", component: <SubClient /> },
  { path: "/admin/master/media", component: <Media /> },
  { path: "/admin/master/agent", component: <Agent /> },
  { path: "/admin/master/staff", component: <Staff /> },
  { path: "/admin/release-order", component: <AllReleaseOrders /> },
  { path: "/admin/all-release-order", component: <AllRo /> },
  { path: "/admin/edit-release-order/:id", component: <EditReleaseOrder /> },
  { path: "/admin/add-invoice", component: <AddInvoice /> },
  { path: "/admin/all-invoice", component: <AllInvoice /> },
  { path: "/admin/edit-invoice/:id", component: <EditInvoice /> },
  { path: "/admin/my-company", component: <MyCompany /> },
  { path: "/admin/attendance", component: <StaffAttendance /> },
  { path: "/admin/all-attendance", component: <AllAttendance /> },
  { path: "/admin/all-vendors", component: <AllVendors /> },
  { path: "/admin/vendor-purchase", component: <Purchase /> },
  {
    path: "/create-Invoice-by-releaseorder/:part1/:part2/:part3",
    component: <CreateInvoiceByReleaseOrder />,
  },
  {
    path: "/admin/create-splitsbill",
    component: <Splitbills />,
  },
  {
    path: "/admin/holiday",
    component: <AllHolidays />,
  },
  {
    path: "/admin/media-details/:id",
    component: <MediaDetails />,
  },
  {
    path: "/admin/salaries",
    component: <StaffSalary />,
  },
  {
    path: "/admin/salarycount",
    component: <SalaryCount />,
  },
  {
    path: "/admin/vendor/category",
    component: <Categories />,
  },
  {
    path: "/admin/vendor/products",
    component: <Products />,
  },
  {
    path: "/admin/vendor/buyer-data",
    component: <Buyers />,
  },
  {
    path: "/admin/vendor/buyer-data-details/:id",
    component: <BuyerDetails />,
  },
  {
    path: "/admin/advance-salary-staff",
    component: <AdvanceSalary />,
  },
  {
    path: "/admin/staff-lic",
    component: <StaffLic />,
  },
  {
    path: "/admin/quotation",
    component: <AllQuotation />,
  },
  {
    path: "/admin/advertising-type",
    component: <AdvertisingType />,
  },
  {
    path: "/admin/media-rate",
    component: <MediaRate />,
  },
  {
    path: "/admin/create-quotation",
    component: <Quotation />,
  },
  {
    path: "/admin/edit-quotation/:id",
    component: <EditQuotation />,
  },
  {
    path: "/admin/branding/category",
    component: <BrandingCategory />,
  },
  {
    path: "/admin/branding/vendors",
    component: <BrandingVendors />,
  },
  {
    path: "/admin/branding/referral-agencies",
    component: <ReferralAgencies />,
  },
  {
    path: "/admin/branding/orders",
    component: <BrandingOrders />,
  },
  {
    path: "/admin/all-split-bill",
    component: <AllSplitbills />,
  },
  {
    path: "/admin/quotation-category",
    component: <QuotationCategory />,
  },
  {
    path: "/admin/split-bill-details/:id",
    component: <SplitBillDetails />,
  },
  {
    path: "/admin/create-size-wise-splitbill/:id",
    component: <CreateSizeWiseSplitBill />,
  },
  { path: "/admin/add-split-sizes/:id", component: <AddSplitSizes /> },
  {
    path: "/admin/edit-split-sizes/:id",
    component: <EditSizeWiseSplitBill />,
  },
  {
    path: "/admin/edit-size-wise-splitbill/:id",
    component: <EditSplitSizes />,
  },
  {
    path: "/admin/all-invoice-payments",
    component: <AllInvoicePayments />,
  },
  {
    path: "/admin/all-release-order-payments",
    component: <AllReleaseOrderPayments />,
  },
  {
    path: "/admin/finance-reports",
    component: <FinanceReports />,
  },
  {
    path: "/admin/business-reports",
    component: <BusinessReports />,
  },
  {
    path: "/admin/salary-and-attendance-reports",
    component: <SalaryAndAttendanceReport />,
  },
];

const authRoutes = [
  { path: "/", component: <Login /> },
  { path: "/sign-up", component: <SignUp /> },
];

export { userRoutes, authRoutes };
